(function() {
'use strict';

angular.module('ekh')
    .directive('hideSubmenuOnClick', function($window, broker) {
        const directive = {};

        const elements = [];
        const hsHeights = [];

        let isMobile = TRPCONFIG.IsMobileView;

        directive.link = function(scope, element, attr) {
            if (_.find(elements, element) == null) {
                elements.push(element);
            }

            const index = _.findIndex(elements, element);

            function touchedFalsify() {
                elements.forEach(el => {
                    el.touched = false;
                });
            }

            function onMouseEnter() {
                element.addClass('hover');
                element.siblings().removeClass('hover');

                if (!isMobile) {
                    const hs = element.find('.grid-container > div > div > :first-child');

                    for (let i = 0; i < hs.length; i++) {
                        hsHeights.push($(hs[i]).height());
                    }

                    const maxHeight = Math.max(...hsHeights);
                    hs.attr('style', `height: ${maxHeight}px`);
                }

                // Add `keep-in-viewport-x` attribute to keep element on screen
                if ('keepInViewportX' in attr) {
                    keepInViewportX(attr.keepInViewportX);
                }
            }

            function keepInViewportX(selector) {
                const win = $($window);
                const el = selector ? element.find(selector) : element;
                el.css('left', 0);

                let winRight = win.width() + win.scrollLeft() - 28; // Scrollbar
                let elRight = el.offset().left + el.width();
                let delta = elRight - winRight;

                if (delta > 0) {
                    el.css('left', el.position().left - delta);
                }
            }

            element.on('click', () => {
                if ($window.TRPCONFIG.IsTouchDevice) {
                    if (elements[index].touched === false || elements[index].touched == null) {
                        onMouseEnter();
                        touchedFalsify();
                        elements[index].touched = true;
                    } else if (elements[index].touched === true) {
                        element.removeClass('hover');
                        element.siblings().removeClass('hover');
                        touchedFalsify();
                    }
                }
            });

            element.on('mouseenter', () => {
                if (!$window.TRPCONFIG.IsTouchDevice) {
                    onMouseEnter();
                }
            });

            element.children('.sub-menu').find('a').on('click', () => {
                element.removeClass('hover');
            });

            element.on('mouseleave', () => {
                element.removeClass('hover');
            });

            element.find('.menu-item-link').click(() => {
                broker.publish('hideNavigationDrawer');
            });
        };

        return directive;
    })
    .directive('slidePanelItem', function(broker, resourceService) {
        let isMobile = TRPCONFIG.IsMobileView;
        let enableSubMenu = TRPCONFIG.Domain.EnableDestinationsSubMenu;
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            scope: {
                hasChildren: '@'
            },
            link($scope, element) {
                $scope.onItemSelected = function() {
                    if ($scope.hasChildren === 'true') {
                        let dropdowns = document.querySelectorAll('.dropdown');
                        let classes = element[0].classList.value;

                        if (dropdowns.length) {
                            dropdowns[0].classList.remove('dropdown');
                        }

                        if (!classes.includes('dropdown')) {
                            element.addClass('dropdown');
                            if (isMobile && enableSubMenu) {
                                if (element[0].children[1].children[1].children[0].className === 'menu-item-link') {
                                    let items = element[0].children[1].children[1].children;
                                    for (let i = 0; i < items.length; i++) {
                                        items[i].style.display = 'block';
                                    }
                                }
                            }
                        } else {
                            element.removeClass('dropdown');
                            if (isMobile && enableSubMenu) {
                                let items = element[0].children[1].children[1].children;
                                    for (let i = 0; i < items.length; i++) {
                                        items[i].style.display = '';
                                    }
                            }
                        }
                    } else {
                        broker.publish('hideNavigationDrawer');
                    }
                };
                if (isMobile && enableSubMenu) {
                    document.addEventListener('click', function(e) {
                        let target = e.target;
                        let headerTypes = ['h1', 'h2', 'h3', 'h4', 'h5'];
                        if (target.parentElement.firstElementChild.text === resourceService.get('DESTINATIONS')) {
                            $('.menu-item-link').css('display', 'none');
                            const destHeaders = target.parentElement.querySelectorAll('h1,h2,h3,h4,h5');
                            let destHeadersLength = destHeaders ? destHeaders.length : 0;
                            if (destHeadersLength > 0) {
                                for (let i = 0; i < destHeadersLength; i++) {
                                    if (destHeaders[i].children[0] && destHeaders[i].classList.length === 0) {
                                        destHeaders[i].children[0].removeAttribute('class');
                                        destHeaders[i].children[0].classList.add('expand-icon', 'bg-position');
                                    } else {
                                        if (destHeaders[i].children[0] && destHeaders[i].children[0].classList.length > 0) {
                                            destHeaders[i].children[0].removeAttribute('class');
                                        }
                                        destHeaders[i].removeAttribute('class');
                                        destHeaders[i].classList.add('expand-icon', 'bg-position-one');
                                    }
                                }
                            }
                        }

                        if (target.parentElement.firstElementChild.tagName && headerTypes.includes(target.parentElement.firstElementChild.tagName.toLowerCase())) {
                            $(target).parents('.menu-item')[0].classList.add('dropdown');
                            let items = target.parentElement.children[1].children;
                            if (items.length > 0) {
                                subMenuReset(target);
                                for (let i = 0; i < items.length; i++) {
                                    if (items[i].style.display !== 'block') {
                                        items[i].style.display = 'block';
                                        if (headerTypes.includes(target.tagName.toLowerCase())) {
                                            target.removeAttribute('class');
                                            target.classList.add('collapse-icon', 'bg-position-two');
                                        }
                                    } else {
                                        items[i].style.display = 'none';
                                        if (headerTypes.includes(target.tagName.toLowerCase())) {
                                            if (target.children[0] && target.children[0].classList.length > 0) {
                                                target.children[0].removeAttribute('class');
                                            }
                                            target.removeAttribute('class');
                                            target.classList.add('expand-icon', 'bg-position-one');
                                        }
                                    }
                                }
                            }
                        } else if (target.parentElement.firstElementChild.tagName && target.parentElement.firstElementChild.tagName === 'A' &&
                        (headerTypes.includes(target.parentElement.tagName.toLowerCase()))) {
                            $(target).parents('.menu-item')[0].classList.add('dropdown');
                            let items = target.parentElement.parentElement.children[1].children;
                            if (items.length > 0) {
                                subMenuReset(target);
                                for (let i = 0; i < items.length; i++) {
                                    if (items[i].style.display !== 'block') {
                                        items[i].style.display = 'block';
                                        if (target.tagName === 'A') {
                                            if (target.parentElement.classList.length > 0) {
                                                target.parentElement.removeAttribute('class');
                                            }
                                            target.removeAttribute('class');
                                            target.classList.add('collapse-icon', 'bg-position-three');
                                        }
                                    } else {
                                        items[i].style.display = 'none';
                                        if (target.tagName === 'A') {
                                            if (target.parentElement.classList.length > 0) {
                                                target.parentElement.removeAttribute('class');
                                            }
                                            target.removeAttribute('class');
                                            target.classList.add('expand-icon', 'bg-position');
                                        }
                                    }
                                }
                            }
                        }
                    }, false);
                }

                function subMenuReset(target) {
                    if (target.parentElement.firstElementChild.className.includes('expand-icon')) {
                        $('.menu-item-link').css('display', 'none');
                        const grid = $(target).parents('.grid-container');
                        const destHeaders = grid[0].querySelectorAll('h1,h2,h3,h4,h5');
                        let destHeadersLength = destHeaders ? destHeaders.length : 0;
                        if (destHeadersLength > 0) {
                            for (let i = 0; i < destHeadersLength; i++) {
                                if (destHeaders[i].children[0] && destHeaders[i].classList.length === 0) {
                                    destHeaders[i].children[0].removeAttribute('class');
                                    destHeaders[i].children[0].classList.add('expand-icon', 'bg-position');
                                } else {
                                    if (destHeaders[i].children[0] && destHeaders[i].children[0].classList.length > 0) {
                                        destHeaders[i].children[0].removeAttribute('class');
                                    }
                                    destHeaders[i].removeAttribute('class');
                                    destHeaders[i].classList.add('expand-icon', 'bg-position-one');
                                }
                            }
                        }
                    }
                }
            },
            template: '<li ng-click="onItemSelected()"><i class="icon icon-chevron-down hide"></i><ng-transclude></ng-transclude></li>'
        };
    });
})();
